export const isRebookPriceWithAirlineFees = (rebookPrice) => {
    return rebookPrice.airlineFees !== undefined;
};
